module.exports = __webpack_public_path__ + "assets/big-cancel-icon.fef4f4e8.svg";